import React, { useState, useEffect } from "react";
import ModalComponent from "../../Components/Modal/Modal";
import { useToggle } from "../../Hook";
import { getClass, getClassCategories, handleLogErrorToSlack } from "../../Helper";
import axios from "axios";
import { notify } from "react-notify-toast";
import uuid from "uuid/v4";
import "./Resume.css";
import "react-datepicker/dist/react-datepicker.css";
import { connect } from "react-redux";
import {
  updateQualification,
  updateProfessionalDevelopment,
  updateProfessionalExperience,
  updateRefereeCheck,
  updateNonTeachingExperience,
  updateVetTrainingQualification,
  updateVetIndustryQualification,
  updateVetProfessionalDevelopment,
  updateVetTrainingExperience,
  updateVetIndustryExperience,
  updateVetTrainerMatrix,
} from "../../redux/homePage/homePage.actions";
import ConfirmButton from "../../Components/Buttons/ConfirmButton";
import CancelButton from "../../Components/Buttons/CancelButton";
import FormField from "../../Components/FormField/FormField";
import FormDropdown from "../../Components/FormField/FormDropdown";
import FormDatePicker from "../../Components/FormField/FormDatePicker";
import FormMultiSelect from "../../Components/FormField/FormMultiSelect";
import HoverIcon from "../../Components/FormField/HoverIcon-nova";
import CheckableButton from "../../Components/CheckableButton/CheckableButton";
import { API } from "../../API";
import moment from "moment";
import { Fragment } from "react";
import { getTags } from "../JobBoard/utils";
import DragDropFile from "../../Components/DragUpload/DragDropFile";
import { FormHelperText, FormControl, Input } from '@mui/material'; 

function ModalForm(props) {
  //Yuan: Redux actions
  const {
    updateQualification,
    updateProfessionalDevelopment,
    updateProfessionalExperience,
    updateRefereeCheck,
    updateNonTeachingExperience,
    updateVetTrainingQualification,
    updateVetIndustryQualification,
    updateVetProfessionalDevelopment,
    updateVetTrainingExperience,
    updateVetIndustryExperience,
    updateVetTrainerMatrix,
  } = props;

  const [user, setUser] = useState();
  const [isCreate, toggleCreate] = useToggle(props.isCreate);
  const [startDate, setStartDate] = useState(
    props.content.start_date
      ? Date.parse(
          `${props.content.start_date.substring(
            0,
            2
          )}/01/${props.content.start_date.substring(3, 7)}`
        )
      : new Date()
  );
  const [graduationDate, setGraduationDate] = useState(
    props.content.graduation_date && props.content.graduation_date !== "Present"
      ? Date.parse(
          `${props.content.graduation_date.substring(
            0,
            2
          )}/01/${props.content.graduation_date.substring(3, 7)}`
        )
      : new Date()
  );
  const [gradDatePickerVisible, toggleGradDatePicker] = useToggle(
    props.content.end_date !== "Present"
  );
  const [gradQDatePickerVisible, toggleQGradDatePicker] = useToggle(
    props.content.graduation_date !== "Present"
  );
  const [pd_startDate, setpd_StartDate] = useState(new Date());
  const [pdDatePickerVisible, togglePdDatePicker] = useToggle(
    props.content.end_date !== "Present"
  );
  const [pd_endDate, setpd_EndDate] = useState(
    props.content.end_date && props.content.end_date !== "Present"
      ? Date.parse(
          `${props.content.end_date.substring(
            0,
            2
          )}/01/${props.content.end_date.substring(3, 7)}`
        )
      : new Date()
  );
  const [course_class_delivered, setcourse_class_delivered] = useState(
    props.content.course_class_delivered || []
  );
  const [can_deliver, setcan_deliver] = useState();

  const [qualification_fileName, setQualification_fileName] = useState(null);
  const qualification = isCreate
    ? null
    : props.user.qualifications.filter((q) => q._id === props.qualificationID);
  const professional_development = isCreate
    ? null
    : props.user.professional_developments.filter(
        (q) => q._id === props.qualificationID
      );
  let [link, setLink] = useState(
    props.content ? props.content.qualification_url : ""
  );
  let [fName, setFName] = useState(
    props.content ? props.content.certificate_filename : ""
  );
  let [transcript_link, settranscript_Link] = useState(
    props.content ? props.content.transcript_url : ""
  );
  let [transcript_fName, settranscript_FName] = useState(
    props.content ? props.content.transcript_filename : ""
  );
  let [enrolment_link, setenrolment_Link] = useState(
    props.content ? props.content.enrolment_url : ""
  );
  let [enrolment_fName, setenrolment_FName] = useState(
    props.content ? props.content.enrolment_filename : ""
  );
  let [referee, setreferee] = useState(false);
  let [referrer_organisations, setReferrer_organisations] = useState(
    getRef_Organisations()
  );

  const [matrix_link, setMatrixLink] = useState(
    props.content ? props.content.matrix_url : ""
  );
  const [matrix_file_name, setMatrixFileName] = useState(
    props.content ? props.content.matrix_file_name : ""
  );
  const [matrix_upload_date, setMatrixUploadDate] = useState(
    props.content ? props.content.matrix_uploaded_date : ""
  );

  const [cities, setCities] = useState([])
  const [city, setCity] = useState(null)
  const [country, setCountry] = useState(null)
  const [countryList,setCountryList] = useState([])

  const all_class_types = getClass();
  const all_categories = getClassCategories();

  const DOCUMENT_DELETE_MSG = "Deleted the document successfully";

  const eltGroupedOptions = () => {
    const categories = ["ge", "exam", "manage", "academic", "vet", "ld"];
    const groupedOptions = [];
    for (let cat of categories) {
      const obj = {};
      obj.label = all_categories.find((c) => c.value === cat).name;
      obj.options = all_class_types
        .filter((cls) => cls.type[0] === cat)
        .map((cls) => {
          return { value: cls.key, label: cls.whole_name };
        });
      groupedOptions.push(obj);
    }
    return groupedOptions;
  };

  const vetGroupedOptions = () => {
    const categories = [
      "bsb",
      "chc",
      "cua",
      "fns",
      "fsk",
      "shb",
      "hlt",
      "ict",
      "sit",
    ];
    const groupedOptions = [];
    for (let cat of categories) {
      const obj = {};
      obj.label = all_categories.find((c) => c.value === cat).name;
      obj.options = all_class_types
        .filter((cls) => cls.type[0] === cat)
        .map((cls) => {
          return { value: cls.key, label: cls.whole_name };
        });
      groupedOptions.push(obj);
    }
    return groupedOptions;
  };

  // const elt_class_types = all_class_types
  //   .filter((cl) => {
  //     const categories = ["ge", "exam", "manage", "academic", "vet", "ld"];

  //     return !!cl.type.find((type) => categories.includes(type));
  //   })
  //   .map((c) => {
  //     return { value: `${c.key}`, label: `${c.whole_name}` };
  //   });

  // const vet_class_types = all_class_types
  //   .filter((cl) => {
  //     const categories = all_categories
  //       .filter((cat) => {
  //         return cat.type === "vet";
  //       })
  //       .map((cat) => {
  //         return cat.value;
  //       });
  //     categories.push("exp-vet");
  //     return !!cl.type.find((type) => categories.includes(type));
  //   })
  //   .sort((a, b) => {
  //     return a.whole_name > b.whole_name ? 1 : -1;
  //   })
  //   .map((c) => {
  //     return { value: `${c.key}`, label: `${c.whole_name}` };
  //   });

  const max_word_count = 75;

  // const class_types = all_class_types.filter(cl => {
  //   return (
  //     cl.type.includes("ge") ||
  //     cl.type.includes("exam") ||
  //     cl.type.includes("manage") ||
  //     cl.type.includes("academic") ||
  //     cl.type.includes('bsb') ||
  //     cl.type.includes('chc') ||
  //     cl.type.includes('fns') ||
  //     cl.type.includes('fsk') ||
  //     cl.type.includes('shb') ||
  //     cl.type.includes('ict') ||
  //     cl.type.includes('sit') ||
  //     cl.type.includes("other")
  //   )
  // })
  //   .map((c) => {
  //     return { value: `${c.key}`, label: `${c.whole_name}` };
  //   });

  // Todo
  function getRef_Organisations() {
    let user = Object.assign({}, props.user);
    let organisation = new Set();
    if (user.professional_experience && user.professional_experience.length > 0)
      user.professional_experience.forEach((pe) => {
        organisation.add(pe.organisation);
      });
    if (user.vet_industry_exp && user.vet_industry_exp.length > 0)
      user.vet_industry_exp.forEach((vie) => {
        organisation.add(vie.organisation);
      });
    if (user.vet_training_exp && user.vet_training_exp.length > 0)
      console.log(user);
      user.vet_training_exp.forEach((vte) => {
        organisation.add(vte.organisation);
      });
    return Array.from(organisation);
  }

  const deleteTrainerMatrix = () => {
    setMatrixLink(null);
    setMatrixFileName(null);
    setMatrixUploadDate(null);
  };

  const deleteCertificate = (e) => {
    setLink(null);
    setFName(null);
  };

  const deleteTranscript = (e) => {
    settranscript_Link(null);
    settranscript_FName(null);
  };

  const deleteEnrolment = (e) => {
    setenrolment_Link(null);
    setenrolment_FName(null);
  };
  const handleClose = () => {
    props.resetAllFilesUpload()
    props.showPopup(false);
  };

  const prepareValue = (id, dataQualification, dataTranscript, dataEnrolment) => {
    const institution_name = document
      .querySelector("#institution")
      .value.trim();
    //  const description = document.querySelector("#description").value;
    // const degree = document.querySelector("#degree").value;
    const major = document.querySelector("#major").value;
    const award_name = document.querySelector("#award_name").value;
    const start_date = document.querySelector("#start_date").value;
    //const graduation_date = document.querySelector("#graduation_date").value;
    const qualification_url = props.certificateFile ? (dataQualification?.link || '') : link
    const transcript_url = props.transcriptFile ? (dataTranscript?.link || '') : transcript_link
    const enrolment_url = props.evidenceEnrolmentFile ? (dataEnrolment?.link || '') : enrolment_link
    const certificate_filename = props.certificateFile ? (dataQualification?.fileName || '') : fName
    const transcript_filename = props.transcriptFile ? (dataTranscript?.fileName || '') : transcript_fName
    const enrolment_filename = props.evidenceEnrolmentFile ? (dataEnrolment?.fileName || '') : enrolment_fName
    const institution_website = document.querySelector("#institution-website")
      .value;
    const verification_status = false;
    const graduation_date = document.querySelector("#current_date").checked
      ? "Present"
      : document.querySelector("#graduation_date").value;

    const institution_city = city || ""
    const institution_country = country || ""

    const newQualification = {
      institution_name: institution_name,
      // degree: degree,
      major: major,
      qualification_url: qualification_url,
      qualification_status: false,
      transcript_url: transcript_url,
      enrolment_url: enrolment_url,
      transcript_status: false,
      certificate_filename: certificate_filename,
      transcript_filename: transcript_filename,
      enrolment_filename: enrolment_filename,
      institution_website: institution_website,
      // institution_location: institution_location,
      award_name: award_name,
      start_date: start_date,
      graduation_date: graduation_date,
      verification_status: verification_status,
      institution_city,
      institution_country,
      _id: id,
      // description: description
    };
    return newQualification;
  };

  const preparePDValue = (id) => {
    const activity = document.querySelector("#activity").value;
    const location = document.querySelector("#location").value;
    const end_date = document.querySelector("#end_date").checked
      ? "Present"
      : document.querySelector("#pd_endDate").value;
    const focus_event = document.querySelector("#focus_event").value;
    const institution_country = country || ''
    const institution_city = city || ''

    const newQualification = {
      activity: activity,
      location: location,
      end_date: end_date,
      focus_event: focus_event,
      institution_country,
      institution_city,
      _id: id,
    };
    return newQualification;
  };

  const prepareExValue = (id, hide_courses) => {
    const organisation = document.querySelector("#organisation").value;
    const start_date = document.querySelector("#start_date").value;
    const end_date = document.querySelector("#current_date").checked
      ? "Present"
      : document.querySelector("#end_date").value;
    const institution_country = country || ''
    const institution_city = city || ''

    const newExperience = {
      organisation: organisation,
      course_class_delivered: course_class_delivered,
      start_date: start_date,
      end_date: end_date,
      institution_country,
      institution_city,
      _id: id,
    };

    if (hide_courses) {
      newExperience.role_held = document.querySelector("#role_held").value;
    }
    return newExperience;
  };

  const prepareRefereeValue = (id) => {
    const referee_first_name =
      document.querySelector("#referee_first_name") !== null
        ? document.querySelector("#referee_first_name").value
        : "";
    const referee_last_name =
      document.querySelector("#referee_last_name") !== null
        ? document.querySelector("#referee_last_name").value
        : "";
    const referee_email =
      document.querySelector("#referee_email") !== null
        ? document.querySelector("#referee_email").value
        : "";
    const referee_position_title =
      document.querySelector("#referee_position_title") !== null
        ? document.querySelector("#referee_position_title").value
        : "";

    const organisation =
      document.querySelector("#referrer_organisation") !== null
        ? document.querySelector("#referrer_organisation").value
        : "";
    const newReferee = {
      organisation: organisation,
      referee_first_name: referee_first_name,
      referee_last_name: referee_last_name,
      referee_email: referee_email,
      referee_position_title: referee_position_title,
      _id: id,
      flag: false,
    };
    return newReferee;
  };

  const prepareNonTeachingExValue = (id) => {
    const organisation = document.querySelector("#organisation").value;
    const role_held = document.querySelector("#role_held").value;
    const main_duties = document.querySelector("#main_duties").value;
    const start_date = document.querySelector("#start_date").value;
    const end_date = document.querySelector("#current_date").checked
      ? "Present"
      : document.querySelector("#end_date").value;
    const institution_country = country || ''
    const institution_city = city || ''

    const newNonTeachingExperience = {
      organisation: organisation,
      // institution_location: institution_location,
      role_held: role_held,
      main_duties: main_duties,
      start_date: start_date,
      end_date: end_date,
      institution_country,
      institution_city,
      _id: id,
    };
    return newNonTeachingExperience;
  };

  const sendEmailNotification = (tpenIndx, emailType) => {
    API.sendTeacherProfileProgressEmail({
      _id: props.user._id,
      to: props.user.email,
      first_name: props.user.first_name,
      etype: emailType,
    }).then((result) => {
        console.log("result:", result);
      })
      .catch((err) => {
        console.log("err:", err);
      });
  };

  const prepareTrainerMatrixInfo = (id) => {
    const newMatrix = {
      matrix_url: matrix_link,
      matrix_filename: matrix_file_name,
      matrix_upload_date: matrix_upload_date,
      matrix_status: false,
      _id: id,
    };

    return newMatrix;
  };

  const prepareCommonQualInfo = (isVet, dataQualification, dataTranscript, dataEnrolment) => {
    const degree = isVet ? document.querySelector("#degree")?.value : '';
    const award_name = document.querySelector("#award_name")?.value;
    let course_code, major;
    if (isVet) {
      course_code = document.querySelector("#course_code")?.value;
    } else {
      major = document.querySelector("#major").value;
    }
    const institution_name = document
      .querySelector("#institution")
      .value.trim();

    const institution_website = document.querySelector("#institution-website")
      .value;
    const start_date = document.querySelector("#start_date").value;
    const graduation_date = document.querySelector("#current_date").checked
      ? "Present"
      : document.querySelector("#graduation_date").value;

    const qualification_url = props.certificateFile ? (dataQualification?.link || '') : link
    const transcript_url = props.transcriptFile ? (dataTranscript?.link || '') : transcript_link
    const enrolment_url = props.evidenceEnrolmentFile ? (dataEnrolment?.link || '') : enrolment_link
    const certificate_filename = props.certificateFile ? (dataQualification?.fileName || '') : fName
    const transcript_filename = props.transcriptFile ? (dataTranscript?.fileName || '') : transcript_fName
    const enrolment_filename = props.evidenceEnrolmentFile ? (dataEnrolment?.fileName || '') : enrolment_fName
    const institution_city = city || ""
    const institution_country = country || ""

    const qual_data = {
      award_name,
      major,
      institution_name,
      institution_website,
      start_date,
      graduation_date,
      qualification_url,
      certificate_filename,
      qualification_status: false,
      transcript_url,
      transcript_filename,
      transcript_status: false,
      enrolment_url,
      enrolment_filename,
      verification_status: false,
      institution_city,
      institution_country,
    };

    if (isVet) {
      qual_data.course_code = course_code;
      qual_data.degree = degree
    } else {
      qual_data.major = major;
    }

    return qual_data;
  };

  const prepareVetQualification = (id, dataQualification, dataTranscript, dataEnrolment) => {
    const commonInfo = prepareCommonQualInfo(true, dataQualification, dataTranscript, dataEnrolment);

    const newTrainingQual = {
      ...commonInfo,
      _id: id,
    };

    return newTrainingQual;
  };

  const submitVetQualification = async (event, dispatchAction) => {
    let updateType = "";
    event.preventDefault();
    const id = uuid();

    // upload File to S3
    let dataQualification = {}
    let dataTranscript = {}
    let dataEnrolment = {}

    if (gradQDatePickerVisible) {
      if (!props.isEdit && !props.certificateFile) {
        notify.show("Please upload your certificate");
        return
      }
      if (props.certificateFile) {
        dataQualification = await handleUploadFileDragDrop(props.certificateFile, "qualification", qualificatonUploadingCompleted)
      }

      if (props.transcriptFile) {
        dataTranscript = await handleUploadFileDragDrop(props.transcriptFile, "qualification/transcript", transcriptUploadingCompleted)
      }
    } else {
      if (!props.isEdit && !props.evidenceEnrolmentFile) {
        notify.show("Please upload your evidence enrolment");
        return
      }
      if (props.evidenceEnrolmentFile) {
        dataEnrolment = await handleUploadFileDragDrop(props.evidenceEnrolmentFile, "qualification/enrolment", enrolmentUploadingCompleted)
      }
    }

    const newQualification = prepareVetQualification(id, dataQualification, dataTranscript, dataEnrolment);
    const content_id = props.content._id;
    const valid = checkFiles(newQualification, true);

    if (valid) {
      props.showPopup(false);

      sendEmailNotification(6, "QUAL_CONF");

      if (props.isEdit) {
        updateType = "EDIT";
        dispatchAction({ newQualification, updateType, content_id });
      } else {
        updateType = "ADD";
        dispatchAction({ newQualification, updateType });
      }

      props.resetAllFilesUpload()
    }
  };

  const submitVetTrainingQual = (event) => {
    submitVetQualification(event, updateVetTrainingQualification);
  };

  const submitVetIndustryQual = (event) => {
    submitVetQualification(event, updateVetIndustryQualification);
  };

  const submitProfDev = (dispatchAction) => {
    let updateType = "";
    const id = uuid();

    const newProfDev = preparePDValue(id);
    const content_id = props.content._id;

    props.showPopup(false);
    if (props.content !== "") {
      updateType = "EDIT";
      dispatchAction({
        newProfDev,
        updateType,
        content_id,
      });
    } else {
      updateType = "ADD";
      dispatchAction({
        newProfDev,
        updateType,
      });
    }
  };

  const submitEltProfDev = () => {
    submitProfDev(updateProfessionalDevelopment);
  };

  const submitVetProfDev = () => {
    submitProfDev(updateVetProfessionalDevelopment);
  };

  const submitExperience = (e, dispatchAction, hide_courses) => {
    let updateType = "";
    e.preventDefault();
    const id = uuid();
    const content_id = props.content._id;

    const newProfExperience = prepareExValue(id, hide_courses);
    if (hide_courses || newProfExperience.course_class_delivered.length > 0) {
      props.showPopup(false);

      // Email notification
      sendEmailNotification(5, "PEXP_CONF");

      if (props.content !== "") {
        updateType = "EDIT";
        dispatchAction({
          newProfExperience,
          updateType,
          content_id,
        });
      } else {
        updateType = "ADD";
        dispatchAction({ newProfExperience, updateType });
      }
    } else {
      notify.show("Please select courses/classes delivered", "warning");
    }
  };

  const submitEltExperience = (event) => {
    submitExperience(event, updateProfessionalExperience);
  };

  const submitVetTrainingExperience = (event) => {
    submitExperience(event, updateVetTrainingExperience);
  };

  const submitVetIndustryExperience = (event) => {
    submitExperience(event, updateVetIndustryExperience, true);
  };

  const submitTrainerMatrix = (e) => {
    let updateType = "";
    e.preventDefault();
    const id = uuid();

    const newMatrix = prepareTrainerMatrixInfo(id);
    if (
      newMatrix.matrix_filename !== "" &&
      newMatrix.matrix_filename !== null
    ) {
      props.showPopup(false);

      updateType = "ADD";
      updateVetTrainerMatrix({ newMatrix, updateType });
    } else {
      notify.show("Please upload trainer matrix file");
      //notify.show("Please upload trainer matrix file", "warning");
    }
  };

  const handleSave = async (event) => {
    let updateType = "";
    event.preventDefault();
    const id = props.isEdit ? props.content._id : uuid();

    // upload File to S3
    let dataQualification = {}
    let dataTranscript = {}
    let dataEnrolment = {}

    if (gradQDatePickerVisible) {
      if (!props.isEdit && !props.certificateFile) {
        notify.show("Please upload your certificate");
        return
      }
      if (!props.isEdit && !props.transcriptFile) {
        notify.show("Please upload your transcript");
        return
      }
      if (props.certificateFile) {
        dataQualification = await handleUploadFileDragDrop(props.certificateFile, "qualification", qualificatonUploadingCompleted)
      }

      if (props.transcriptFile) {
        dataTranscript = await handleUploadFileDragDrop(props.transcriptFile, "qualification/transcript", transcriptUploadingCompleted)
      }
    } else {
      if (!props.isEdit && !props.evidenceEnrolmentFile) {
        notify.show("Please upload your evidence enrolment");
        return
      }
      if (props.evidenceEnrolmentFile) {
        dataEnrolment = await handleUploadFileDragDrop(props.evidenceEnrolmentFile, "qualification/enrolment", enrolmentUploadingCompleted)
      }
    }

    // ======= Prepare values =======
    const newQualification = prepareValue(id, dataQualification, dataTranscript, dataEnrolment);
    const content_id = props.content._id;
    const valid = checkFiles(newQualification);
    if (valid) {
      // ======= Close popup =======
      props.showPopup(false);

      // Email notification
      sendEmailNotification(6, "QUAL_CONF");

      // ======= Update user  =======
      //   const newUser = Object.assign({}, props.user);
      if (props.isEdit) {
        updateType = "EDIT";
        updateQualification({ newQualification, updateType, content_id });
      } else {
        updateType = "ADD";
        updateQualification({ newQualification, updateType });
      }

      props.resetAllFilesUpload()
    }
  };

  const checkFiles = (newQualification, isVet) => {
    let isvalid = true;
    if (document.getElementById("qualification-date-file").getAttribute('hidden')) {
      return isvalid
    }

    if (!document.querySelector("#current_date").checked) {
      if (
        newQualification.certificate_filename === "" ||
        newQualification.certificate_filename === null ||
        !newQualification.certificate_filename

      ) {
        notify.show("Please upload your certificate");
        isvalid = false;
      } else if (
        !isVet &&
        (newQualification.transcript_filename === "" ||
          newQualification.transcript_filename === null ||
          !newQualification.transcript_filename
        )
      ) {
        notify.show("Please upload your transcript");
        isvalid = false;
      } else {
        isvalid = true;
      }
    } else if (
      newQualification.enrolment_filename === "" ||
      newQualification.enrolment_filename === null ||
      !newQualification.enrolment_filename
    ) {
      notify.show("Please upload your statement of Enrolment");
      isvalid = false;
    }
    
    return isvalid;
  };

  const handleRefereeDetails = () => {
    const id = uuid();
    let updateType = "";
    const content_id = props.content._id;
    const newRefereeCheck = prepareRefereeValue(id.replace(/-/g, ''));
    // console.log("newRefereeCheck: ", newRefereeCheck, content_id)
    const capitalize = (str) => {
      return str ? str[0].toUpperCase() + str.slice(1) : "";
    };
    props.showPopup(false);
    // ======= Update user  =======
    const newUser = Object.assign({}, props.user);
    let ref_email = newRefereeCheck.referee_email;
    let ref_fname = capitalize(newRefereeCheck.referee_first_name);
    let ref_lname = capitalize(newRefereeCheck.referee_last_name);
    let user_fname = capitalize(newUser.first_name);
    let user_lname = capitalize(newUser.last_name);
    let user_id = newUser._id;
    let ref_id = props.content ? props.content._id : newRefereeCheck._id;
    if (props.content !== "") {
      updateType = "EDIT";
      updateRefereeCheck({ newRefereeCheck, updateType, content_id });
    } else {
      updateType = "ADD";
      updateRefereeCheck({ newRefereeCheck, updateType });
    }
    triggerReferenceCheck(
      ref_email,
      ref_fname,
      ref_lname,
      user_fname,
      user_lname,
      user_id,
      ref_id
    );
  };

  const handleSaveNonTeachingEx = (e) => {
    e.preventDefault();
    const id = uuid();
    let updateType = "";
    // ======= Prepare values =======
    const newNonTeachingExperience = prepareNonTeachingExValue(id);
    const content_id = props.content._id;

    const word_count = newNonTeachingExperience.main_duties.match(/\S+/g)
      .length;

    if (word_count <= max_word_count) {
      // ======= Close popup =======
      props.showPopup(false);
      // ======= Update user  =======
      if (props.content !== "") {
        updateType = "EDIT";
        updateNonTeachingExperience({
          newNonTeachingExperience,
          updateType,
          content_id,
        });
      } else {
        updateType = "ADD";
        updateNonTeachingExperience({ newNonTeachingExperience, updateType });
      }
    } else {
      notify.show(`Field should not exceed ${max_word_count} words.`);
    }
  };

  // const updateUser = (user) => {
  //   // props.addQualification(user);
  //   // ======= Update localStorage =======
  //   window.localStorage.setItem("user", JSON.stringify(user));

  //   //Todo: save the qualification into database
  //   axios
  //     .put(`${PORT}/updateUser`, {
  //       user: user,
  //     })
  //     .then((res) => {
  //       console.log("successful");
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  const triggerReferenceCheck = (
    referee_email,
    referee_first_name,
    referee_last_name,
    teacher_first_name,
    teacher_last_name,
    teacher_id,
    referee_id
  ) => {
    const data = {
      to: referee_email,
      rfname: referee_first_name,
      rlname: referee_last_name,
      tfname: teacher_first_name,
      tlname: teacher_last_name,
      link: `https://www.readyteacherapp.com/NavigateToReferenceForm?tid=${teacher_id}&rid=${referee_id}`,
    };
    API.sendReferenceCheck(data)
      .then((res) => {
        console.log("successful");

        // Email notification
        API.sendTeacherProfileProgressEmail({
          _id: props.user._id,
          to: props.user.email,
          first_name: props.user.first_name,
          etype: "REE_CONF",
        }).then((result) => {
            console.log("result:", result);
          })
          .catch((err) => {
            console.log("err:", err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleDDLChange = (e) => {
    if (e !== null) {
      e.length > 0
        ? setcourse_class_delivered(e)
        : setcourse_class_delivered([]);
      if (e.length > 0) {
        updateCanDeliver(e);
      }
    }
  };

  //When select a degree in qualification form, change happen
  const changeforselectELTdegree = (e) => {
    if (
      e.target.value === "Cambridge CELTA" ||
      e.target.value === "Cambridge DELTA" ||
      e.target.value === "Trinity TESOL"
    ) {
      // document.getElementById("award_name").setAttribute("disabled", true);
      // document.getElementById("award_name").setAttribute("placeholder", "");
      // document.getElementById("award_name").value = "";
      document.getElementById("major").setAttribute("disabled", true);
      document.getElementById("major").setAttribute("placeholder", "");
      document.getElementById("major").value = "";
    } else {
      // document.getElementById("award_name").removeAttribute("disabled");
      document.getElementById("major").removeAttribute("disabled");
      // console.log(
      //   document.getElementById("award_name").getAttribute("disabled")
      // );
    }
  };

  const changeforselectVETdegree = (e) => {
    if (e.target.value === "No VET Training Qualification") {
      document.getElementById("institution-info").setAttribute("hidden", true);
      document.getElementById("qualification-date-file").setAttribute("hidden", true);
      document.getElementById("institution").removeAttribute("required");
      // document.getElementById("institution-location").removeAttribute("required");
      document.getElementById("institution-website").removeAttribute("required");
    } else {
      document.getElementById("institution-info").removeAttribute("hidden");
      document.getElementById("qualification-date-file").removeAttribute("hidden");
      document.getElementById("institution").setAttribute("required", true);
      // document.getElementById("institution-location").setAttribute("required", true);
      document.getElementById("institution-website").setAttribute("required", true);
    }
  };

  // const updateCanDeliver = (cds) => {
  //   let canDelivers = [];
  //   const setCanDeliver = (cd, c) => {
  //     return {
  //       _id: uuid(),
  //       can_deliver: cd.value,
  //       bg_color: c.bg_color,
  //       whole_name: c.whole_name,
  //       short_name: c.short_name,
  //     };
  //   };

  //   cds.forEach((cd) => {
  //     class_type.forEach((c) => {
  //       if (c.name === cd.value) {
  //         canDelivers.push(setCanDeliver(cd, c));
  //       }
  //     });
  //   });
  //   const newUser = Object.assign({}, props.user);

  //   const filterCandeliver = () => {
  //     if (newUser.can_deliver && newUser.can_deliver.length > 0) {
  //       canDelivers.forEach(function (cd) {
  //         newUser.can_deliver = newUser.can_deliver.filter(
  //           (c) => c.can_deliver !== cd.can_deliver
  //         );
  //         if (newUser.can_deliver.includes(cd.can_deliver)) {
  //         } else {
  //           newUser.can_deliver.push(cd);
  //         }
  //       });
  //     } else {
  //       newUser.can_deliver = [...canDelivers];
  //     }
  //   };
  //   filterCandeliver();
  //   setcan_deliver(newUser.can_deliver);
  // };

  const updateCanDeliver = (cds) => {
    // let canDelivers = [];
    let canDelivers = {
      ge: [],
      exam: [],
      manage: [],
      online: [],
      tt: [],
      academic: [],
      // tech: [String], // not used yet
      lms: [],
      vet: [],
      ld: [],

      bsb: [],
      chc: [],
      cpp: [],
      cua: [],
      fns: [],
      fsk: [],
      hlt: [],
      ict: [],
      shb: [],
      sis: [],
      sit: [],
      tae: [],
      vet_other: [],
    };

    if (cds) {
      cds.forEach((cd) => {
        const cl = all_class_types.find((c) => {
          return c.key === cd.value;
        });
        cl.type.forEach((type) => {
          if (canDelivers[type]) {
            canDelivers[type].push(cl.key);
          }
        });
      });
    }

    setcan_deliver(canDelivers);
  };

  const uploadDocument = (id) => {
    document.getElementById(id).click();
  };

  const uploadFileToServer = (e, fileNamePrefix, uploadingCompleted) => {
    const file = e.target.files[0];

    if (file) {
      const [preFileName, fileType] = e.target.files[0].name.split(".");
      const fileName = preFileName
        .replace(/[^\w.]/gi, "")

      API.uploadFileToS3({
        fileName: `${fileNamePrefix}${fileName}`,
        fileType: fileType,
        _id: props.user._id,
      })
        .then((res) => {
          const returnData = res.data.data.returnData;
          const signedRequest = returnData.signedRequest;
          const url = returnData.url;
          const options = {
            headers: {
              "Content-Type": fileType,
            },
          };
          axios
            .put(signedRequest, file, options)
            .then((res2) => {
              const newUser = Object.assign({}, props.user);
              const cut_length = "https://platform-backend-files.s3.amazonaws.com/"
                .length;
              const suffix = url.substring(cut_length, url.length);
              const prefix =
                // "https://n35tl2czql.execute-api.ap-southeast-2.amazonaws.com/default/getfile?path=";
                "https://zps3crms67.execute-api.ap-southeast-2.amazonaws.com/default/getfile3?path="; 
              const new_url = prefix + suffix;
              const urlSplittedArray = url.split(
                `${props.user._id}/${fileNamePrefix}`
              );

              uploadingCompleted(newUser, new_url, fileName, urlSplittedArray);

              // API.updateUser({
              //     user: newUser,
              //   })
              //   .then((res3) => {
              //     console.log("Uploaded Successfully");
              //   })
              //   .catch((error) => {
              //     console.log(error);
              //   });
            })
            .catch((error1) => {
              handleLogErrorToSlack(error1, true)
              console.log(error1);
            });
        })
        .catch((err) => {
          alert(JSON.stringify(err));
        });
    } else {
      console.log("Upload Error");
    }
  };

  const handleUploadFileDragDrop = async (file, fileNamePrefix, uploadingCompleted) => {
    if (file) {
      try {
        props.toggleLoading(true)

        const [preFileName, fileType] = file.name.split(".");
        const fileName = preFileName
          .replace(/[^\w.]/gi, "")
          .replace(/  +/g, "");

        const formData = new FormData();
        formData.append("file", file);
        formData.append("fileName", `${fileNamePrefix}${fileName}`)
        const response = await API.uploadCompressedFileToS3(formData)

        const url = response?.data?.data
        const cut_length = "https://platform-backend-files.s3.amazonaws.com/".length;
        const suffix = url.substring(cut_length, url.length);
        const prefix = "https://zps3crms67.execute-api.ap-southeast-2.amazonaws.com/default/getfile3?path=";
        const new_url = prefix + suffix;
  
        const urlSplittedArray = url.split(
          `${props.user._id}/${fileNamePrefix}`
        );
        const newUser = Object.assign({}, props.user);
        uploadingCompleted(newUser, new_url, fileName, urlSplittedArray);

        props.toggleLoading(false)

        return {
          link: new_url,
          fileName: urlSplittedArray[1],
        }

      } catch (error) {
        props.toggleLoading(false)
        notify.show("File cannot uploaded. Please choose another file.")
        handleLogErrorToSlack(error, true);
        console.log(error);
      }
    }
  }

  const uploadFileToServerV2 = (e, fileNamePrefix, uploadingCompleted) => {
    const file = e.target.files[0];
    const fileExtension = file?.name?.split('.')?.[1]
    const imagesFileType = ['png', 'jpg', 'jpeg', 'pdf']

    if (!imagesFileType.includes(fileExtension)) {
      notify.show("You are uploading the wrong file type")
      return 
    }

    if (file) {
      props.toggleLoading(true)

      const [preFileName, fileType] = e.target.files[0].name.split(".");
      const fileName = preFileName
        .replace(/[^\w.]/gi, "")

      const formData = new FormData();
      formData.append("file", file);
      formData.append("fileName", `${fileNamePrefix}${fileName}`)
      API.uploadCompressedFileToS3(formData)
        .then((response) => {
          const url = response?.data?.data
          const cut_length = "https://platform-backend-files.s3.amazonaws.com/".length;
          const suffix = url.substring(cut_length, url.length);
          const prefix = "https://zps3crms67.execute-api.ap-southeast-2.amazonaws.com/default/getfile3?path=";
          const new_url = prefix + suffix;
    
          const urlSplittedArray = url.split(
            `${props.user._id}/${fileNamePrefix}`
          );
          const newUser = Object.assign({}, props.user);
          uploadingCompleted(newUser, new_url, fileName, urlSplittedArray);
        })
        .catch(error => {
          console.log("error", error)
          notify.show("File cannot uploaded. Please choose another file.")
        })
        .finally(() => {
          props.toggleLoading(false)
        })
    } else {
      console.log("Upload Error");
    }
  };

  const updateQualificationForUser = (newUser, newUrl, fileName) => {
    newUser.qualification_url = newUrl;
    newUser.qualification_filename = fileName;
  };

  const matrixUploadingCompleted = (
    newUser,
    newUrl,
    fileName,
    urlSplittedArray
  ) => {
    setMatrixLink(newUrl);
    setMatrixFileName(urlSplittedArray[1]);
    setMatrixUploadDate(moment().format("MM/YYYY"));
  };

  const handleSaveMatrixFile = (e) => {
    uploadFileToServerV2(e, "trainermatrix", matrixUploadingCompleted);
  };

  const qualificatonUploadingCompleted = (
    newUser,
    newUrl,
    fileName,
    urlSplittedArray
  ) => {
    updateQualificationForUser(newUser, newUrl, fileName);

    setQualification_fileName(fileName);
    setLink(newUrl);
    setFName(urlSplittedArray[1]);
  };

  const handleSaveQualificationFile = (e) => {
    uploadFileToServerV2(e, "qualification", qualificatonUploadingCompleted);
  };

  const transcriptUploadingCompleted = (
    newUser,
    newUrl,
    fileName,
    urlSplittedArray
  ) => {
    updateQualificationForUser(newUser, newUrl, fileName);

    setQualification_fileName(fileName);
    settranscript_Link(newUrl);
    settranscript_FName(urlSplittedArray[1]);
  };

  const handleSaveTranscriptFile = (e) => {
    uploadFileToServerV2(
      e,
      "qualification/transcript",
      transcriptUploadingCompleted
    );
  };

  const enrolmentUploadingCompleted = (
    newUser,
    newUrl,
    fileName,
    urlSplittedArray
  ) => {
    newUser.enrolment_url = newUrl;
    newUser.enrolment_filename = fileName;

    setQualification_fileName(fileName);
    setenrolment_Link(newUrl);
    setenrolment_FName(urlSplittedArray[1]);
  };

  const handleSaveEnrolmentFile = (e) => {
    uploadFileToServerV2(
      e,
      "qualification/enrolment",
      enrolmentUploadingCompleted
    );
  };

  const formatGroupLabel = (data) => (
    <div style={{ fontSize: "1.2rem", color: "#3bb4d8"}}>
      <span>{data.label}</span>
    </div>
  );

  const onSelectCountry = (e) => {
    setCountry(e.target.value)
    const cities = countryList[e.target.value]
    setCities(cities)
    setCity('')
  }

  const handleCityChange = (e) => {
    setCity(e.target.value)
  }


  const buildCommonQualificationContent = (isVet, isVetTraining) => {
    const eltAwardTypes = [
      <option value="PhD in">PhD</option>,
      <option value="Master of/in">Master’s Degree</option>,
      <option value="Bachelor of">Bachelor’s Degree</option>,
      <option value="Graduate Diploma of/in">Graduate Diploma</option>,
      <option value="Graduate Certificate in">Graduate Certificate</option>,
      <option value="Advanced Diploma of/in">Advanced Diploma</option>,
      <option value="Diploma of/in">Diploma</option>,
      <option value="Certificate IV in">Certificate IV</option>,
      <option value="Certificate III in">Certificate III</option>,
      <option value="Certificate II in">Certificate II</option>,
      <option value="Certificate I in">Certificate I</option>,
      <option value="Cambridge CELTA">Cambridge CELTA</option>,
      <option value="Cambridge DELTA"> Cambridge DELTA</option>,
      <option value="Trinity TESOL"> Trinity TESOL</option>,
    ];

    const vetAwardTypes = [
        <option value="PhD in">PhD</option>,
        <option value="Master of/in">Master’s Degree</option>,
        <option value="Bachelor of">Bachelor’s Degree</option>,
        <option value="Graduate Diploma of/in">Graduate Diploma</option>,
        <option value="Graduate Certificate in">Graduate Certificate</option>,
        <option value="Advanced Diploma of/in">Advanced Diploma</option>,
        <option value="Diploma of/in">Diploma</option>,
        <option value="Certificate IV in">Certificate IV</option>,
        <option value="Certificate III in">Certificate III</option>,
        <option value="Certificate II in">Certificate II</option>,
        <option value="Certificate I in">Certificate I</option>,
        <option value="Cambridge CELTA">Cambridge CELTA</option>,
        <option value="Cambridge DELTA"> Cambridge DELTA</option>,
        <option value="Trinity TESOL"> Trinity TESOL</option>,
    ];

    const vetTrainingAwardTypes = [
      <option value="TAE40122 Certificate IV in Training and Assessment">
        TAE40122 Certificate IV in Training and Assessment
      </option>,
      <option value="TAE40116 Certificate IV in Training and Assessment">
        TAE40116 Certificate IV in Training and Assessment
      </option>,
      <option value="TAE40110 Certificate IV in Training and Assessment">
        TAE40110 Certificate IV in Training and Assessment plus the following units:
        TAELLN411 (or its successor) or TAELLN401A,
        and TAEASS502 (or its successor) or TAEASS502A or TAEASS502B
      </option>,
      <option value="Diploma or higher level qualification in adult education">
        A diploma or higher level qualification in adult education
      </option>,
      <option value="No VET Training Qualification">
        I do not currently hold nor am I currently undertaking any of the above qualifications and can
        therefore deliver non-accredited courses only
      </option>
    ]

    return (
      <Fragment>
        <div className="row">
          <div className="col-md-6">
            <FormDatePicker
              label="Start Date"
              id="start_date"
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              selectsStart
              startDate={startDate}
              endDate={graduationDate}
              dateFormat="MM/yyyy"
              showMonthYearPicker
              value={startDate}
              placeholderText={new Date()}
              isClearable
              maxWidth
              noMargin
              required
            />
            <CheckableButton
              checkbox
              id="current_date"
              name="current_date"
              defaultChecked={
                props.content
                  ? props.content.graduation_date === "Present"
                  : false
              }
              onChange={toggleQGradDatePicker}
              noBorder
            >
              Currently Enrolled
            </CheckableButton>

            <div id='institution-info'>
            </div>
          </div>

          <div className="col-md-6" id='qualification-date-file'>
            <div id="end_date_block" hidden={!gradQDatePickerVisible}>
              <FormDatePicker
                label="Graduation Date"
                id="graduation_date"
                selected={graduationDate}
                onChange={(date) => setGraduationDate(date)}
                selectsEnd
                startDate={startDate}
                endDate={graduationDate}
                dateFormat="MM/yyyy"
                showMonthYearPicker
                value={graduationDate}
                minDate={startDate}
                placeholderText={new Date()}
                isClearable
                maxWidth
                required={gradQDatePickerVisible}
              />
            </div>
          </div>
        </div>

        <div className="row mt-2">
          <div className="col-md-6">
            {
              isVetTraining && (
                <FormDropdown
                  label={isVetTraining ? "Select Training Qualification" : "Award Type"}
                  name="degree"
                  id="degree"
                  required
                  defaultValue={props.content ? props.content.degree : ""}
                  onChange={isVet ? changeforselectVETdegree : changeforselectELTdegree}
                  noMargin
                >
                  <option value="" hidden>
                    Please Select
                  </option>
                  {isVet ? (isVetTraining ? vetTrainingAwardTypes : vetAwardTypes) : eltAwardTypes}
                </FormDropdown>
              )
            }

            {isVetTraining ? null :
              <FormControl className="w-100 input-field"> 
                <label>Award Title</label> 
                <Input
                  id="award_name"
                  name="award_name"
                  defaultValue={
                    props.content
                      ? props.content.award_name
                      : qualification
                      ? qualification[0].major
                      : ""
                  }
                  required
                /> 
                <FormHelperText id="award-title-helper"> 
                  Applied Linguistics
                </FormHelperText> 
              </FormControl>
            }
          </div>
          <div className="col-md-6">
            {isVetTraining ? null : isVet ? (
              <FormControl className="w-100 input-field"> 
                <label>Course Code</label> 
                <Input
                  id="course_code"
                  name="course_code"
                  defaultValue={props.content
                    ? props.content.course_code
                    : qualification
                    ? qualification[0].details
                    : ""
                  }
                /> 
                <FormHelperText id="course_code_helper"> 
                  TAE40116
                </FormHelperText> 
              </FormControl> 
            ) : (
              <FormControl className="w-100 input-field"> 
                <label>Major/s</label> 
                <Input
                  id="major"
                  name="major"
                  defaultValue={
                    props.content
                      ? props.content.major
                      : qualification
                      ? qualification[0].details
                      : ""
                  }
                /> 
                <FormHelperText id="major-helper"> 
                  Separate majors with comma
                </FormHelperText> 
              </FormControl>
            )}
          </div>
        </div>

        <div className="row mt-2">
          <div className="col-md-6">
            <FormControl className="w-100 input-field"> 
              <label>Institution Name</label> 
              <Input
                id="institution"
                name="institution"
                required
                defaultValue={
                  props.content
                    ? props.content.institution_name
                    : qualification
                    ? qualification[0].institution_name
                    : ""
                }
              /> 
              <FormHelperText id="institution-helper"> 
                University of Sydney
              </FormHelperText> 
            </FormControl>
          </div>
          <div className="col-md-6">
            <FormControl className="w-100 input-field"> 
              <label>Institution Website</label> 
              <Input
                id="institution-website"
                name="institution-website"
                required
                defaultValue={
                  props.content ? props.content.institution_website : ""
                }
              /> 
              <FormHelperText id="institution-website-helper"> 
                sydney.edu.au
              </FormHelperText> 
            </FormControl>
          </div>
        </div>

        <div className="row mt-2">
          <div className="col-md-6">
            <FormDropdown
              label="Institution Country"
              id="institution_country"
              // className="col-md-6 px-0 px-md-3"
              required
              value={country || props.content.institution_country}
              onChange={onSelectCountry}
            >
              <option value="">Please Choose</option>
              {countryList ? Object.keys(countryList).map((country, index) => (
                <option key={index} value={country}>{country}</option>
              )) : null }
            </FormDropdown>
          </div>

          <div className="col-md-6">
            <FormDropdown
              label="Institution City"
              id="institution_city"
              // className="col-md-6 px-0 px-md-3"
              required
              value={city || props.content.institution_city}
              onChange={handleCityChange}
            >
              <option value="" hidden>Please Choose</option>
              {
                cities
                  ? cities?.map((city, index) => {
                    return <option value={city} key={index}>{city}</option>
                  })
                  : null
              }
            </FormDropdown>
          </div>
        </div>

        <div className="row mt-5 justify-content-center">
          <div className="col-md-12" hidden={!gradQDatePickerVisible}>
            <DragDropFile
              title="Upload or drop your DEGREE CERTIFICATE here"
              fileType="certificate"
              handleChangeFile={props.handleChangeFileDragDrop}
              file={props.certificateFile}
              fileName={fName}
              link={link}
            />
          </div>
          <div className="col-md-12" hidden={!gradQDatePickerVisible || isVetTraining}>
            <DragDropFile
              title="Upload or drop your ACADEMIC TRANSCRIPT here"
              fileType="transcript"
              handleChangeFile={props.handleChangeFileDragDrop}
              file={props.transcriptFile}
              fileName={transcript_fName}
              link={transcript_link}
            />
          </div>

          <div className="col-md-12" hidden={gradQDatePickerVisible}>
            <DragDropFile
              title="Upload or drop your ENVIDENCE OF ENROLMENT here"
              fileType="evidence-enrolment"
              handleChangeFile={props.handleChangeFileDragDrop}
              file={props.evidenceEnrolmentFile}
              fileName={enrolment_fName}
              link={enrolment_link}
            />
          </div>
        </div>

        <div className="row mt-5">
          <div className="col-md-6 mb-2 mb-md-0">
            <CancelButton type="back" value="Back" onClick={handleClose}>
              Cancel
            </CancelButton>
          </div>
          <div className="col-md-6">
            <ConfirmButton type="submit">Submit</ConfirmButton>
          </div>
        </div>
      </Fragment>
    );
  };

  const buildCommonProfDevContent = (is_vet) => {
    return (
      <Fragment>
        <div className="row">
          <div className="col-md-6">
            <FormDropdown
              label="Activity"
              id="activity"
              name="activity"
              required
              defaultValue={props.content ? props.content.activity : ""}
              noMargin
            >
              <option value="">Please Select</option>
              <option>Attend industry webinar</option>
              <option>Attend industry PD event</option>
              {!is_vet && <option>Attend English Australia PD event</option>}
              <option>Present at industry event </option>
              <option>Attend in-house PD or training event</option>
              <option>Present at in-house PD event </option>
              {!is_vet && <option>Attend English Australia webinar</option>}
              <option>Watch recorded webinar</option>
              <option>Peer-observe someone's lesson</option>
              <option>Be observed teaching a lesson</option>
              <option>Complete professional course</option>
            </FormDropdown>

            <FormField
              className="mt-3"
              label="Delivering Organisation"
              id="location"
              name="location"
              placeholder="Melbourne University"
              required
              defaultValue={props.content ? props.content.location : ""}
              noMargin
            />

            <FormField
              className="mt-3"
              label="What was the focus of this event?"
              name="focus_event"
              id="focus_event"
              placeholder="Give a brief description"
              required
              defaultValue={props.content ? props.content.focus_event : ""}
            />
          </div>

          <div className="col-md-6">
            <div id="end_date_block" hidden={!pdDatePickerVisible}>
              <FormDatePicker
                label="Completion Date"
                name="pd_endDate"
                id="pd_endDate"
                selected={pd_endDate}
                maxDate={new Date()}
                onSelect={(date) => setpd_EndDate(date)}
                // onChange={date => setpd_EndDate(date)}
                dateFormat="MM/yyyy"
                showMonthYearPicker
                value={pd_endDate}
                placeholderText={new Date()}
                isClearable
                noMargin
                maxWidth
                required={pdDatePickerVisible}
              />
            </div>
            <CheckableButton
              checkbox
              id="end_date"
              name="end_date"
              defaultChecked={
                props.content ? props.content.end_date === "Present" : false
              }
              onChange={togglePdDatePicker}
              noBorder
            >
              Currently Enrolled
            </CheckableButton>
          </div>
        </div>

        { buildInstitutionCityAndCountry() }

        <div className="row mt-3">
          <div className="col-md-6 mb-2 mb-md-0">
            <CancelButton type="back" value="Back" onClick={handleClose}>
              Cancel
            </CancelButton>
          </div>
          <div className="col-md-6">
            <ConfirmButton type="submit">Submit</ConfirmButton>
          </div>
        </div>
      </Fragment>
    );
  };

  const buildCommonExpContent = (is_vet, hide_courses) => {
    return (
      <Fragment>
        <div className="row">
          <div className="col-md-6">
            <FormDatePicker
              label="Starting Date"
              id="start_date"
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              selectsStart
              startDate={startDate}
              endDate={graduationDate}
              dateFormat="MM/yyyy"
              showMonthYearPicker
              value={startDate}
              placeholderText={new Date()}
              isClearable
              noMargin
              maxWidth
              required
            />

            <CheckableButton
              checkbox
              id="current_date"
              name="current_date"
              defaultChecked={
                props.content && props.content.end_date === "Present"
              }
              onChange={toggleGradDatePicker}
              noBorder
            >
              Currently working in this role
            </CheckableButton>
          </div>
          <div className="col-md-6">
            <div id="end_date_block" hidden={!gradDatePickerVisible}>
              <FormDatePicker
                label="End Date"
                name="end_date"
                id="end_date"
                selected={graduationDate}
                onChange={(date) => setGraduationDate(date)}
                selectsEnd
                startDate={startDate}
                endDate={graduationDate}
                dateFormat="MM/yyyy"
                showMonthYearPicker
                value={graduationDate}
                minDate={startDate}
                placeholderText={new Date()}
                isClearable
                noMargin
                maxWidth
                required={gradDatePickerVisible}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <FormField
              label="Organisation"
              name="organisation"
              id="organisation"
              placeholder="Trinity College"
              required
              defaultValue={props.content ? props.content.organisation : ""}
              noMargin
            />
          </div>
          <div className="col-md-6">
            {hide_courses ? (
              <FormField
                label="Role Held"
                name="role_held"
                id="role_held"
                placeholder="Customer Service"
                required
                defaultValue={props.content ? props.content.role_held : ""}
                noMargin
              />
            ) : (
              <FormMultiSelect
                label="Courses/Classes Delivered or Role Held"
                id="course_class_delivered"
                name="course_class_delivered"
                onChange={handleDDLChange}
                options={is_vet ? vetGroupedOptions() : eltGroupedOptions()}
                formatGroupLabel={formatGroupLabel}
                isSearchable
                isMulti
                required
                defaultValue={props.content ? course_class_delivered : ""}
                noMargin
              />
            )}
          </div>
        </div>

        { buildInstitutionCityAndCountry() }

        <div className="row mt-3">
          <div className="col-md-6 mb-2 mb-md-0">
            <CancelButton type="back" value="Back" onClick={handleClose}>
              Cancel
            </CancelButton>
          </div>
          <div className="col-md-6">
            <ConfirmButton type="submit">Submit</ConfirmButton>
          </div>
        </div>
      </Fragment>
    );
  };

  const buildInstitutionCityAndCountry = () => {
    return (
      <div className="row mt-2">
        <div className="col-md-6">
          <FormDropdown
            label="Institution Country"
            id="institution_country"
            // className="col-md-6 px-0 px-md-3"
            required
            value={country || props.content.institution_country}
            onChange={onSelectCountry}
          >
            <option value="">Please Choose</option>
            {countryList ? Object.keys(countryList).map((country, index) => (
              <option key={index} value={country}>{country}</option>
            )) : null }
          </FormDropdown>
        </div>

        <div className="col-md-6">
          <FormDropdown
            label="Institution City"
            id="institution_city"
            // className="col-md-6 px-0 px-md-3"
            required
            value={city || props.content.institution_city}
            onChange={handleCityChange}
          >
            <option value="" hidden>Please Choose</option>
            {
              cities
                ? cities?.map((city, index) => {
                  return <option value={city} key={index}>{city}</option>
                })
                : null
            }
          </FormDropdown>
        </div>
      </div>
    )
  }

  const qualificationForm = () => {
    return (
      <ModalComponent
        show={true}
        className="qualification-form-modal"
        header="Qualification"
        onClose={handleClose}
      >
        <div className="model-main-content">
          <form onSubmit={handleSave}>{buildCommonQualificationContent()}</form>
        </div>
      </ModalComponent>
    );
  };

  const vetTrainingQualForm = () => {
    return (
      <ModalComponent
        show={true}
        className="qualification-form-modal"
        header="Training Qualification"
        onClose={handleClose}
      >
        <div className="model-main-content">
          <form onSubmit={submitVetTrainingQual}>
            {buildCommonQualificationContent(true, true)}
          </form>
        </div>
      </ModalComponent>
    );
  };

  const vetIndustryQualForm = () => {
    return (
      <ModalComponent
        show={true}
        className="qualification-form-modal"
        header="Industry Qualification"
        onClose={handleClose}
      >
        <div className="model-main-content">
          <form onSubmit={submitVetIndustryQual}>
            {buildCommonQualificationContent(true)}
          </form>
        </div>
      </ModalComponent>
    );
  };

  const pdForm = () => {
    return (
      <ModalComponent
        show={true}
        className="qualification-form-modal"
        header="Professional Development"
        onClose={handleClose}
      >
        <div className="model-main-content">
          <form onSubmit={submitEltProfDev}>{buildCommonProfDevContent()}</form>
        </div>
      </ModalComponent>
    );
  };

  const vetProfDevForm = () => {
    return (
      <ModalComponent
        show={true}
        className="qualification-form-modal"
        header="Professional Development"
        onClose={handleClose}
      >
        <div className="model-main-content">
          <form onSubmit={submitVetProfDev}>
            {buildCommonProfDevContent(true)}
          </form>
        </div>
      </ModalComponent>
    );
  };

  const peForm = () => {
    return (
      <ModalComponent
        show={true}
        className="qualification-form-modal"
        header={props.user?.is_childhood_teacher ? "Childcare Experience" : "English Teaching Experience"}
        onClose={handleClose}
      >
        <div className="model-main-content">
          <form onSubmit={submitEltExperience}>{buildCommonExpContent()}</form>
        </div>
      </ModalComponent>
    );
  };

  const vetTrainingExpForm = () => {
    return (
      <ModalComponent
        show={true}
        className="qualification-form-modal"
        header="Teaching Experience"
        onClose={handleClose}
      >
        <div className="model-main-content">
          <form onSubmit={submitVetTrainingExperience}>
            {buildCommonExpContent(true)}
          </form>
        </div>
      </ModalComponent>
    );
  };

  const vetIndustryExpForm = () => {
    return (
      <ModalComponent
        show={true}
        className="qualification-form-modal"
        header="Industry Experience"
        onClose={handleClose}
      >
        <div className="model-main-content">
          <form onSubmit={submitVetIndustryExperience}>
            {buildCommonExpContent(true, true)}
          </form>
        </div>
      </ModalComponent>
    );
  };

  const refForm = () => {
    return (
      <ModalComponent
        show={true}
        className="qualification-form-modal"
        header="Referee"
        onClose={handleClose}
      >
        <div className="model-main-content">
          <form onSubmit={handleRefereeDetails}>
            <div class="row">
              <div className="col-md-6">
                <FormDropdown
                  label="Referrer Organisation"
                  name="referrer_organisation"
                  id="referrer_organisation"
                  required
                  defaultValue={props.content ? props.content.organisation : ""}
                  noMargin
                  onMouseEnter={() => referrer_organisations.length === 0 ?
                    notify.show("Please complete Professional Experience section of your Resume before entering referee details.") : null}
                >
                  {referrer_organisations &&
                  referrer_organisations.length > 0 ? (
                    referrer_organisations.map((item) => (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    ))
                  ) : (
                    <option>{notify.show("Please complete Professional Experience section of your Resume before entering referee details.")}</option>
                  )}
                </FormDropdown>

                <FormField
                  label="Referee First Name"
                  name="referee_first_name"
                  id="referee_first_name"
                  placeholder="First Name"
                  required
                  defaultValue={
                    props.content ? props.content.referee_first_name : ""
                  }
                  noMargin
                />

                <FormField
                  label="Referee Last Name"
                  name="referee_last_name"
                  id="referee_last_name"
                  placeholder="Last Name"
                  required
                  defaultValue={
                    props.content ? props.content.referee_last_name : ""
                  }
                  noMargin
                />
              </div>
              <div className="col-md-6">
                <FormField
                  label="Referee Position Title"
                  name="referee_position_title"
                  id="referee_position_title"
                  placeholder="Position Title"
                  required
                  defaultValue={
                    props.content ? props.content.referee_position_title : ""
                  }
                  noMargin
                />

                <FormField
                  label="Referee Email"
                  type="email"
                  name="referee_email"
                  id="referee_email"
                  placeholder="Email"
                  // pattern="^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$"
                  title="Please enter valid email address"
                  required
                  defaultValue={
                    props.content ? props.content.referee_email : ""
                  }
                  noMargin
                />
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-md-6 mb-2 mb-md-0">
                <CancelButton type="back" value="Back" onClick={handleClose}>
                  Cancel
                </CancelButton>
              </div>
              <div
                className="col-md-6"
                onMouseEnter={() => referrer_organisations.length === 0 ?
                  notify.show("Please complete Professional Experience section of your Resume before entering referee details.") : null}
              >
                <ConfirmButton type="submit">Submit</ConfirmButton>
              </div>
            </div>
          </form>
        </div>
      </ModalComponent>
    );
  };
  const nonTeachingExperienceForm = () => {
    return (
      <ModalComponent
        show={true}
        className="qualification-form-modal"
        header="Other Professional Experience"
        onClose={handleClose}
      >
        <div className="model-main-content">
          <form onSubmit={handleSaveNonTeachingEx}>
            <div className="row">
              <div className="col-md-6">
                <FormDatePicker
                  label="Starting Date"
                  id="start_date"
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  selectsStart
                  startDate={startDate}
                  endDate={graduationDate}
                  dateFormat="MM/yyyy"
                  showMonthYearPicker
                  value={startDate}
                  placeholderText={new Date()}
                  isClearable
                  noMargin
                  maxWidth
                  required
                />

                <CheckableButton
                  checkbox
                  id="current_date"
                  name="current_date"
                  defaultChecked={
                    props.content && props.content.end_date === "Present"
                  }
                  onChange={toggleGradDatePicker}
                  noBorder
                >
                  Currently working in this role
                </CheckableButton>
              </div>
              <div className="col-md-6">
                <div id="end_date_block" hidden={!gradDatePickerVisible}>
                  <FormDatePicker
                    label="End Date"
                    name="end_date"
                    id="end_date"
                    selected={graduationDate}
                    onChange={(date) => setGraduationDate(date)}
                    selectsEnd
                    startDate={startDate}
                    endDate={graduationDate}
                    dateFormat="MM/yyyy"
                    showMonthYearPicker
                    value={graduationDate}
                    minDate={startDate}
                    placeholderText={new Date()}
                    isClearable
                    noMargin
                    maxWidth
                    required={gradDatePickerVisible}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <FormField
                  label="Organisation"
                  name="organisation"
                  id="organisation"
                  placeholder="Officeworks"
                  required
                  defaultValue={props.content ? props.content.organisation : ""}
                  noMargin
                />
              </div>
              <div className="col-md-6">
                <FormField
                  label="Main Duties"
                  name="main_duties"
                  id="main_duties"
                  placeholder={`Separate main duties with comma (Max ${max_word_count} words)`}
                  required
                  defaultValue={props.content ? props.content.main_duties : ""}
                  noMargin
                />
              </div>
              <div className="col-md-6 mt-2">
                <FormField
                  label="Role Held"
                  name="role_held"
                  id="role_held"
                  placeholder="Customer Service"
                  required
                  defaultValue={props.content ? props.content.role_held : ""}
                  noMargin
                />
              </div>
            </div>
            { buildInstitutionCityAndCountry() }
            <div className="row mt-5">
              <div className="col-md-6 mb-2 mb-md-0">
                <CancelButton type="back" value="Back" onClick={handleClose}>
                  Cancel
                </CancelButton>
              </div>
              <div className="col-md-6">
                <ConfirmButton type="submit">Submit</ConfirmButton>
              </div>
            </div>
          </form>
        </div>
      </ModalComponent>
    );
  };

  const vetTrainerMatrixForm = () => {
    return (
      <ModalComponent
        show={true}
        className="qualification-form-modal"
        header="Trainer Matrix"
        onClose={handleClose}
      >
        <div className="model-main-content">
          <form onSubmit={submitTrainerMatrix}>
            <div className="row">
              <div className="col">
                <div className="form-group">
                  <FormField
                    label={"Upload Matrix"}
                    id="matrix"
                    placeholder={
                      matrix_file_name
                        ? matrix_file_name
                        : "No file chosen (.jpg and .pdf files supported)"
                    }
                    disabled
                    header={
                      <>
                        <HoverIcon
                          icon="lock"
                          color="grey"
                          text="Your documents will be encrypted and stored securely"
                        />
                        <HoverIcon
                          icon="info circle"
                          color="grey"
                          text="Please upload a file less than 600KB."
                        />
                      </>
                    }
                    sideButton={{
                      onClick: () => uploadDocument("upload_trainer_matrix"),
                      id: "Select_Button",
                      label: matrix_file_name ? "Uploaded" : "Select",
                      small: true,
                      disabled: matrix_file_name,
                    }}
                    footer={
                      matrix_file_name ? (
                        <div className="text-left d-flex">
                          <a
                            href={`/NavigateToFileViewer?fileurl=${matrix_link}`}
                            target="_blank"
                          >
                            <p className="uploaded-file-name mt-1 ml-1">
                              {matrix_file_name}
                            </p>
                          </a>
                          <i
                            className="mdi mdi-delete-circle d-flex mt-1 ml-1 uploaded-file-delete-icon"
                            onClick={deleteTrainerMatrix}
                          ></i>
                        </div>
                      ) : (
                        ""
                      )
                    }
                  />
                  <input
                    type="file"
                    id="upload_trainer_matrix"
                    name="upload_trainer_matrix"
                    onChange={handleSaveMatrixFile}
                    style={{ display: "none" }}
                    accept=".jpg, .pdf"
                  />
                </div>
              </div>
            </div>

            <div className="row mt-5">
              <div className="col-md-6 mb-2 mb-md-0">
                <CancelButton type="back" value="Back" onClick={handleClose}>
                  Cancel
                </CancelButton>
              </div>
              <div className="col-md-6">
                <ConfirmButton type="submit">Submit</ConfirmButton>
              </div>
            </div>
          </form>
        </div>
      </ModalComponent>
    );
  };

  const getCountries = async () => {
    try {
      const list = await API.getCountriesV2();
      const countries = list.data.data
      setCountryList(countries)

      const country = props.content.institution_country
      const city = props.content.institution_city
      if (Object.keys(countries).length > 0 && country && city) {
        const cities = countries[country]
        setCities(cities)
        setCity(city)
        setCountry(country)
      }
    } catch(err) {console.log('getCountries Err:',err)}
  }

  useEffect(() => {
    // Change the date picker style
    const date_picker = document.querySelectorAll(".react-datepicker-wrapper");
    if (date_picker.length !== 0) {
      for (let i = 0; i < date_picker.length; i++) {
        date_picker[i].style.display = "block";
      }
    }
  });

  useEffect(() => {
    getCountries()
  }, [])

  return (
    <>
      {props.formType === "qualification" && qualificationForm()}
      {props.formType === "PD" && pdForm()}
      {props.formType === "PE" && peForm()}
      {props.formType === "NTE" && nonTeachingExperienceForm()}
      {props.formType === "referee" && refForm()}
      {props.formType === "VTQ" && vetTrainingQualForm()}
      {props.formType === "VIQ" && vetIndustryQualForm()}
      {props.formType === "VPD" && vetProfDevForm()}
      {props.formType === "VTE" && vetTrainingExpForm()}
      {props.formType === "VIE" && vetIndustryExpForm()}
      {props.formType === "VTM" && vetTrainerMatrixForm()}
    </>
  );
}

const mapDispatchToProps = (dispatch) => ({
  updateQualification: (user) => dispatch(updateQualification(user)),
  updateProfessionalDevelopment: (user) =>
    dispatch(updateProfessionalDevelopment(user)),
  updateProfessionalExperience: (user) =>
    dispatch(updateProfessionalExperience(user)),
  updateRefereeCheck: (user) => dispatch(updateRefereeCheck(user)),
  updateNonTeachingExperience: (user) =>
    dispatch(updateNonTeachingExperience(user)),
  updateVetTrainingQualification: (user) =>
    dispatch(updateVetTrainingQualification(user)),
  updateVetIndustryQualification: (user) =>
    dispatch(updateVetIndustryQualification(user)),
  updateVetProfessionalDevelopment: (user) =>
    dispatch(updateVetProfessionalDevelopment(user)),
  updateVetTrainingExperience: (user) =>
    dispatch(updateVetTrainingExperience(user)),
  updateVetIndustryExperience: (user) =>
    dispatch(updateVetIndustryExperience(user)),
  updateVetTrainerMatrix: (user) => dispatch(updateVetTrainerMatrix(user)),
});

export default connect(null, mapDispatchToProps)(ModalForm);
